// extracted by mini-css-extract-plugin
module.exports = {"textarea":"TextArea_textarea__HnBUt","counter":"TextArea_counter__W4OxN"};